import React from 'react';

export default (WrappedComponent, initValue = () => true) => (
  class extends React.PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        folded: initValue(props),
      };

      this.toggleFolded = this.toggleFolded.bind(this);
    }

    toggleFolded() {
      this.setState(({ folded }) => ({
        folded: !folded,
      }));
    }

    render() {
      const { folded } = this.state;

      return (
        <WrappedComponent
          folded={folded}
          toggleFolded={this.toggleFolded}
          {...this.props}
        />
      );
    }
  }
);
